import { CountUp } from '@/resources/assets/js/modules/count-up';

class BigNumbers {
  constructor(root) {
    this.root = root;
    this.numbers = root.querySelectorAll('.Number-number span');

    this.#init();
  }

  #init() {
    this.numbers.forEach(num => {
      const obs = new IntersectionObserver(
        this.initCountUp,
        {
          root: null,
          rootMargin: '0px',
          threshold: 0
        }
      );

      obs.USE_MUTATION_OBSERVER = false;
      obs.observe(num);
    });
  }

  initCountUp(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const anim = new CountUp(entry.target, 0, entry.target.dataset.number);
        setTimeout(anim.start, 500);
        observer.unobserve(entry.target);
      }
    });
  }
}

[...document.querySelectorAll('.BigNumbers')].forEach(node => new BigNumbers(node));

